import { ListPartFinderFeedbackResponse, PartFinderFeedback } from '@/api/api';
import { api } from '@/services/api';
import { useTenants } from '@/services/tenants/useTenants';
import { AxiosApiError } from '@/types/apiError';
import type { AxiosResponse } from 'axios';
import { useQuery } from '@tanstack/react-query';

export const PART_FINDER_FEEDBACK_QUERY_KEY = 'partFinderFeedback';

export const usePartFinderFeedback = (reportId: string) => {
  const { getTenantId } = useTenants();
  const tenantId = getTenantId();

  return useQuery<AxiosResponse<ListPartFinderFeedbackResponse>, AxiosApiError, PartFinderFeedback[]>({
    queryKey: [PART_FINDER_FEEDBACK_QUERY_KEY, reportId],
    queryFn: () => api.tenants.listPartFinderFeedback(tenantId, reportId),
    select: response => response.data.feedback,
    enabled: !!reportId && !!tenantId,
  });
};
